const navMenuViewTemplate = `
<span ng-if="!authenticationStatus.authenticated">
    <a href="" class="sr-only sr-only-focusable" ng-click="skipMainNavigation()"
        >Skip main navigation</a
    >
    <span class="site-tagline"> {{ 'header.PreloginText' | translate }} </span>

    <div class="header-secondary-nav">
        <ul class="nav navbar-nav">
            <li>
                <a class="plan-sponsor" href="{{ urls.pscPath }}">
                    {{ 'header.planSponsorLinkContent' | translate }}
                </a>
            </li>
        </ul>
    </div>
</span>

<nav ng-if="authenticationStatus.authenticated" class="main-nav navbar-default">
    <a href="" class="sr-only sr-only-focusable" ng-click="skipMainNavigation()"
        >Skip main navigation</a
    >
    <header-plan-messaging
        class="plan-messaging-nav-menu"
        slides="planMessagingSlides"
        watch-depth="reference"
        prevent="prevent"
        on-view-all-prevent="onViewAllPrevent"
    ></header-plan-messaging>
    <button class="navbar-toggle" ng-click="toggleMenu($event)" type="button">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
    </button>
    <div class="main-nav-menu navbar-section" id="main-nav" ng-class="mobileHeaderClass()">
        <a class="navbar-toggle navbar-toggle-close" ng-click="closeMenu()"> &times; </a>
        <ul class="nav navbar-nav" role="menu">
            <li
                class="menu-item"
                ng-class="{active: homeIsActive()}"
                ng-if="txnAccess.liatEnabled"
                role="menuitem"
            >
                <a class="menu-item-link home" ng-click="homeClickHandler($event)"
                    >{{ 'header.Home' | translate }}</a
                >
            </li>
            <li
                id="AccountMenu"
                class="menu-item"
                ng-class="{active: accountsIsActive()}"
                ng-click="toggleDesktopAccountMenu($event);"
                ng-if="txnAccess.liatEnabled"
                role="menuitem"
            >
                <!-- Account dropdown added -->
                <a
                    class="menu-item-link dropdown-toggle"
                    ng-if="!isMobileBrowser()"
                    data-toggle="dropdown"
                    ng-click="activateAccountDropDown(); accountClick()"
                    >{{ 'header.MyAccounts' | translate }}
                    <i class="fa fa-solid fa-chevron-down"></i>
                </a>
                <ul class="dropdown-menu" ng-if="accountMenuList.length > 1">
                    <li
                        class="menu-item"
                        ng-if="!isMobileBrowser()"
                        ng-repeat="account in accountMenuList"
                    >
                        <!-- Add switch plan feature if plan name has no submenus-->
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="isEnrollmentPlan(account.accountURL) &&
                                    !isEnrollmentPage() && account.currentContext"
                            ng-href="{{getUrlToEnroll(account.accountURL)}}"
                        >
                            {{account.planName}}</a
                        >
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="account.currentContext && isEnrollmentPlan(account.accountURL) && isEnrollmentPage()"
                            ng-click="redirectEnrollmentPage(account.accountURL);"
                        >
                            {{account.planName}}</a
                        >

                        <a
                            class="menu-item-link secondary-link"
                            ng-if="!isEnrollmentPlan(account.accountURL) && account.currentContext"
                        >
                            {{account.planName}}
                            <span class="em-caret-right"></span>
                        </a>
                        <ul
                            class="sub-menu dropdown-menu"
                            ng-if="!isEnrollmentPlan(account.accountURL) && account.currentContext"
                        >
                            <li class="menu-item" ng-repeat="submenu in account.navigationItem">
                                <a
                                    class="menu-item-link secondary-link"
                                    ng-href="{{getUrlForAcctSubMenuItem(submenu, account.groupId)}}"
                                    ng-click="accountDropdownMenuClick(submenu); prevent($event,'ACCOUNT_DROPDOWN')"
                                    >{{submenu.displayText}}</a
                                >
                            </li>
                        </ul>
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="!account.currentContext"
                            ng-click="switchPlan(account);"
                        >
                            {{account.plName}}</a
                        >
                    </li>
                </ul>
                <ul
                    class="dropdown-menu"
                    ng-if="accountMenuList.length === 1 && !isEnrollmentPlan(accountMenuList[0].accountURL)"
                    ng-repeat="account in accountMenuList"
                >
                    <li
                        class="menu-item"
                        ng-if="!isMobileBrowser()"
                        ng-repeat="submenu in account.navigationItem"
                    >
                        <a
                            class="menu-item-link secondary-link"
                            ng-href="{{getUrlForAcctSubMenuItem(submenu, account.groupId)}}"
                            ng-click="accountDropdownMenuClick(submenu); prevent($event,'ACCOUNT_DROPDOWN')"
                            >{{submenu.displayText}}</a
                        >
                    </li>
                </ul>

                <a
                    class="menu-item-link overview"
                    ng-if="isMobileBrowser()"
                    ng-click="toggleAccountMenu($event)"
                    ng-href="{{ participantAppURL }}/#/overview"
                >
                    {{ 'header.MyAccounts' | translate }}
                </a>

                <account-menu-list
                    is-account-selected="isAccountSelected"
                    active-group-account="activeGroupAccount"
                    all-accounts="allAccounts"
                    get-menu-navigation="getMenuNavigation"
                    get-account-hash="getAccountHash"
                    change-account="changeAccount"
                    current-account="currentAccount"
                    toggle-account-menu="toggleAccountMenu"
                    is-active="accountMenuIsActive"
                    set-active-menu-tier="setActiveMenuTier"
                    get-active-menu-tier="getActiveMenuTier"
                    close-menu="closeMenu"
                    ng-show="getAccountDetailsLoaded"
                >
                </account-menu-list>
            </li>

            <li
                class="menu-item"
                ng-class="{active: homeIsActive()}"
                ng-if="!txnAccess.liatEnabled"
                role="menuitem"
            >
                <a
                    class="menu-item-link overview"
                    ng-click="toggleAccountMenu($event); prevent($event,'HOME')"
                    ng-href="{{ participantAppURL }}/#/overview"
                    >{{ 'header.Home' | translate }}</a
                >
            </li>

            <li
                ng-class="{active: accountsIsActive()}"
                id="AccountMenu"
                class="menu-item"
                ng-if="!txnAccess.liatEnabled"
                ng-click="toggleDesktopAccountMenu($event)"
                role="menuitem"
            >
                <a
                    class="menu-item-link dropdown-toggle"
                    data-toggle="dropdown"
                    ng-if="!isMobileBrowser()"
                    ng-click="activateAccountDropDown(); accountClick();"
                >
                    {{ 'header.MyAccounts' | translate }}
                    <i class="fa fa-solid fa-chevron-down"></i>
                </a>
                <ul class="dropdown-menu" ng-if="accountMenuList.length > 1">
                    <li class="menu-item" ng-repeat="account in accountMenuList">
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="isEnrollmentPlan(account.accountURL) && !isEnrollmentPage() && account.currentContext"
                            ng-href="{{getUrlToEnroll(account.accountURL)}}"
                            ng-if="!isMobileBrowser()"
                        >
                            {{account.planName}}
                        </a>
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="isEnrollmentPlan(account.accountURL) && isEnrollmentPage() && account.currentContext"
                            ng-click="redirectEnrollmentPage(account.accountURL);"
                            ng-if="!isMobileBrowser()"
                        >
                            {{account.planName}}
                        </a>
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="!isEnrollmentPlan(account.accountURL) && account.currentContext && !isMobileBrowser()"
                        >
                            {{account.planName}}<span class="em-caret-right"></span>
                        </a>

                        <ul
                            class="sub-menu dropdown-menu"
                            ng-if="!isEnrollmentPlan(account.accountURL) && account.currentContext"
                        >
                            <li class="menu-item" ng-repeat="submenu in account.navigationItem">
                                <a
                                    class="menu-item-link secondary-link"
                                    ng-href="{{getUrlForAcctSubMenuItem(submenu, account.groupId)}}"
                                    ng-click="accountDropdownMenuClick(submenu); prevent($event,'ACCOUNT_DROPDOWN')"
                                    >{{submenu.displayText}}</a
                                >
                            </li>
                        </ul>
                        <a
                            class="menu-item-link secondary-link"
                            ng-if="!account.currentContext"
                            ng-click="switchPlan(account);"
                        >
                            {{account.plName}}</a
                        >
                    </li>
                </ul>
                <ul
                    class="dropdown-menu"
                    ng-if="accountMenuList.length === 1 && !isEnrollmentPlan(accountMenuList[0].accountURL)"
                    ng-repeat="account in accountMenuList"
                >
                    <li
                        class="menu-item"
                        ng-if="!isMobileBrowser()"
                        ng-repeat="submenu in account.navigationItem"
                    >
                        <a
                            class="menu-item-link secondary-link"
                            ng-href="{{getUrlForAcctSubMenuItem(submenu, account.groupId)}}"
                            ng-click="accountDropdownMenuClick(submenu); prevent($event,'ACCOUNT_DROPDOWN')"
                            >{{submenu.displayText}}</a
                        >
                    </li>
                </ul>
                <account-menu-list
                    is-account-selected="isAccountSelected"
                    active-group-account="activeGroupAccount"
                    all-accounts="allAccounts"
                    get-menu-navigation="getMenuNavigation"
                    get-account-hash="getAccountHash"
                    change-account="changeAccount"
                    current-account="currentAccount"
                    toggle-account-menu="toggleAccountMenu"
                    is-active="accountMenuIsActive"
                    set-active-menu-tier="setActiveMenuTier"
                    close-menu="closeMenu"
                    ng-show="getAccountDetailsLoaded"
                    get-active-menu-tier="getActiveMenuTier"
                >
                </account-menu-list>
            </li>

            <!-- GUIDANCE LINK -->
            <li
                class="menu-item"
                ng-class="{active: guidanceIsActive()}"
                ng-if="advice.dataLoaded"
                role="menuitem"
            >
                <a
                    class="menu-item-link guidance-link"
                    ng-href=""
                    ng-click="guidanceClickHandler($event);"
                    ng-if="(txnAccess.changeAllocationsEnabled || advice.managedAccountsAllowed)"
                >
                    {{ 'header.TopNav_Guidance' | translate }}
                </a>
            </li>
            <li
                class="menu-item"
                role="menuitem"
                ng-if="!txnAccess.dnpSSOEnabled && txnAccessServiceData.loaded && !txnAccess.wellnessEnabled"
            >
                <a class="menu-item-link" ng-href="{{educationCenterUrl}}" target="_blank"
                    >{{ 'header.LearningCenter' | translate }}</a
                >
            </li>
            <li
                class="menu-item"
                ng-class="{active: wellnessIsActive()}"
                ng-if="!txnAccess.dnpSSOEnabled && txnAccessServiceData.loaded && txnAccess.wellnessEnabled"
                role="menuitem"
            >
                <a
                    class="menu-item-link overview"
                    ng-click="openWellnessPage($event);"
                    id="nav-wellness"
                    data-groupId="{{ activeGroupAccount.groupId }}"
                    data-individualId="{{ activeGroupAccount.individualId }}"
                    data-nav-value="wellness"
                    ng-href="{{participantAppURL}}/#/wellness"
                >
                    {{ 'header.financialPath' | translate }}
                </a>
            </li>
            <li
                class="menu-item"
                uib-dropdown
                role="menuitem"
                ng-if="txnAccess.dnpSSOEnabled && txnAccessServiceData.loaded && !txnAccess.wellnessEnabled"
            >
                <a
                    class="menu-item-link"
                    uib-dropdown-toggle
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    {{ 'header.LearningCenter' | translate }} <i class="fa fa-solid fa-chevron-down"></i
                ></a>
                <ul class="uib-dropdown-menu" role="menu">
                    <li>
                        <a class="menu-item-link" ng-href="{{educationCenterUrl}}" target="_blank"
                            >{{ 'header.LearningsAndCalculatos' | translate }}</a
                        >
                    </li>
                    <li>
                        <a ng-click="openDNPModal()"
                            >{{ 'header.SavingsBillsManager' | translate }}</a
                        >
                    </li>
                </ul>

                <form class="hide" id="SAMLFORMDNP" method="post" target="_blank"></form>
            </li>
            <li
                class="menu-item"
                ng-class="{active: wellnessIsActive()}"
                ng-if="txnAccess.dnpSSOEnabled && txnAccessServiceData.loaded && txnAccess.wellnessEnabled"
                role="menuitem"
            >
                <a
                    class="menu-item-link overview"
                    ng-click="openWellnessPage($event);"
                    id="nav-wellness"
                    data-groupId="{{ activeGroupAccount.groupId }}"
                    data-individualId="{{ activeGroupAccount.individualId }}"
                    data-nav-value="wellness"
                >
                    {{ 'header.financialPath' | translate }}
                </a>
            </li>

            <li class="menu-item" role="menuitem" ng-if="displayTotalRewards">
                <process-sso-directive
                    custom-text="{{ 'header.TotalRewards' | translate }}"
                    factory-name="Charlton"
                    unique-id="Charlton"
                ></process-sso-directive>
            </li>
            <li id="utility-nav-user" class="utility-nav-item">
                <a
                    class="utility-nav-item-link"
                    title="{{userProfile.data.firstName}} {{userProfile.data.lastName}}"
                    href=""
                    id="navMenuUserProfileName"
                    ng-click="profileClickHandler($event)"
                >
                    {{userProfile.data.firstName}}&nbsp;{{userProfile.data.lastName}}
                </a>
            </li>
            <li class="utility-nav-item">
                <a
                    id="“ppt-logout”"
                    class="utility-nav-item-link"
                    ng-click="logoutClickHandler($event)"
                    title="Log out"
                >
                    {{'header.Logout' | translate}}
                </a>
            </li>
            <li ng-if="showChangeLanguageButton" class="utility-nav-item">
                <a href="" class="utility-nav-item-link" ng-click="showLanguages=!showLanguages"
                    >{{'header.changeLanguage' | translate}}</a
                >
                <a
                    ng-show="showLanguages"
                    ng-repeat="locale in availableLocales"
                    class="margin-left-100 locale utility-nav-item-link"
                    href=""
                    ng-click="setLocale(locale.code)"
                >
                    {{ locale.name }}
                </a>
            </li>
        </ul>
    </div>
    <div class="navbar-mobile-overlay" ng-class="mobileHeaderClass()" ng-click="closeMenu()"></div>
</nav>
`;
export default navMenuViewTemplate;
